export const TipoDocumentoSalesforce = Object.freeze({
  CC: 'CEDULA',
  CE: 'CED.EXTRANJERIA',
  NIT: 'NIT',
});
